export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              全网独家 · 实时追踪
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              爆料专区 · 第一时间掌握全网劲爆内幕
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              你关心的，我们都在挖 — 因为真相从不等人
            </p>

            <p className="text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 text-sm md:text-base">
              爆料专区是国内领先的独家爆料聚合平台，每日24小时不间断追踪娱乐圈大瓜、科技圈内幕、社会热点猛料。
              我们从一线知情人士和深度调查中获取独家信源，每条爆料均经过双重核验后再推送给读者。
              目前平台已累计发布超8万条独家爆料，涵盖娱乐、财经、科技、社会、体育等多个领域，
              其中超过六成为全网首发内容。无论你是职业吃瓜人还是偶尔关注热点的读者，
              这里都能满足你对真相和新鲜瓜料的所有好奇心。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600">8万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计独家爆料</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候不间断更新</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600">8600万</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃读者</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                浏览今日热门爆料
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-800 font-medium rounded-md border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-bar-chart-line"></i>
                查看热议榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/5] max-w-[420px] mx-auto rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20breaking%20news%20and%20media%20journalism%20concept%2C%20warm%20crimson%20red%20and%20amber%20gold%20tones%20on%20deep%20dark%20background%2C%20stylized%20newspaper%20fragments%20and%20geometric%20patterns%20floating%20in%20dynamic%20composition%2C%20dramatic%20spotlight%20effect%20with%20high%20contrast%2C%20editorial%20magazine%20aesthetic%2C%20modern%20digital%20media%20visual%2C%20clean%20bold%20minimal%20style&width=840&height=1050&seq=hero-main&orientation=portrait"
                alt="爆料专区 - 全网独家爆料与热点追踪平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}